import { render, staticRenderFns } from "./FinalRemarkForm.vue?vue&type=template&id=bf3707ca&scoped=true&"
import script from "./FinalRemarkForm.vue?vue&type=script&lang=js&"
export * from "./FinalRemarkForm.vue?vue&type=script&lang=js&"
import style0 from "./FinalRemarkForm.vue?vue&type=style&index=0&id=bf3707ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3707ca",
  null
  
)

export default component.exports